import React, { useEffect, useState } from "react";
import './Admin_table.scss';
import axios from "axios";
import { ClipLoader } from "react-spinners";
import { faL } from "@fortawesome/free-solid-svg-icons";
import { API_BASE } from "../apiBase";
import { Switch } from "@mui/material";
let Admin_table=()=>{


    useEffect(()=>{
      setLoading(true);
       axios.get(`${API_BASE}/admin_details.php`)
        .then(response=>{
          const rows = Array.isArray(response.data) ? response.data : [];
          set_admin_data(rows);
          set_filter_data(rows);
        })
        .catch(error=>console.log(error))
        .finally(() => setLoading(false));

    },[])

    let [admin_data,set_admin_data]=useState([]);
    let [filter_data,set_filter_data]=useState([]);
    let [loading, setLoading] = useState(false); // Loading state



    let filterthedata=(e)=>{
      let searchdata=e.target.value.toLowerCase();
      let fil_data=admin_data.filter((user)=>user.name.toLowerCase().includes(searchdata) || user.id.includes(searchdata) || user.role.toLowerCase().includes(searchdata) || user.username.toLowerCase().includes(searchdata) || user.created_date.toLowerCase().includes(searchdata));
      set_filter_data(fil_data);
      
    }


    return(
        <div className="table-container">

        <div className="input_search">
        <input type="search" placeholder="Search here...." onChange={filterthedata} />
        </div>
        
        <table className="styled-table">
          <thead>
            <tr>
              <th>S.NO</th>
              <th>NAME</th>
              <th>USER_NAME</th>
              <th>PASSWORD</th>
              <th>ROLE</th>
              <th>ANNUAL MALAR</th>
              <th>DATE & TIME</th>

            </tr>
          </thead>
          <tbody>
          {loading && <ClipLoader size={24} color={"orangered"} />}
            {(Array.isArray(filter_data) ? filter_data : []).map((row, index) => (
              <tr key={index}>
                <td>{index+1}</td>
                <td>{row.name }</td>
                <td>{row.username}</td>
                <td>{row.password}</td>
                <td>{row.role}</td>
                <td>
                  <Switch
                    checked={Number(row.annual_malar_access) === 1}
                    onChange={() => {
                      const fd = new FormData();
                      fd.append("request_role", localStorage.getItem("user_role") || "");
                      fd.append("request_user", localStorage.getItem("user_name") || "");
                      fd.append("username", row.username);
                      fd.append("permission_key", "annual_malar");
                      fd.append("allowed", Number(row.annual_malar_access) === 1 ? 0 : 1);
                      axios.post(`${API_BASE}/permissions_update.php`, fd)
                        .then(() => {
                          const updated = filter_data.map((item) => (
                            item.username === row.username
                              ? { ...item, annual_malar_access: Number(item.annual_malar_access) === 1 ? 0 : 1 }
                              : item
                          ));
                          set_filter_data(updated);
                          set_admin_data(updated);
                        })
                        .catch((error) => console.log(error));
                    }}
                    disabled={row.role === "super_admin"}
                    color="warning"
                  />
                </td>
                <td>{row.created_date}  {row.created_time}</td>
              </tr>
            ))}
            
          </tbody>
        </table>
       
      </div>
    )
}
export default Admin_table;
